export const HELP_BASE_URL = 'https://help.depositfix.com';

export const HelpUrls = {
    REDIRECT_AFTER_PAYMENT: `${HELP_BASE_URL}/depositfix-forms/set-up-redirect-after-payment`,
    CAPTCHA: `${HELP_BASE_URL}/faq/can-i-use-hubspot-captcha-with-my-depositfix-forms`,
    TEST_MODE: `${HELP_BASE_URL}/depositfix-forms/test-your-depositfix-form`
};
